module.exports = __webpack_public_path__ + "img/ring_r_c_1_0@3x.e5c1e956.png";